import { render, staticRenderFns } from "./Disclaimers.vue?vue&type=template&id=18c4af39&scoped=true&"
import script from "./Disclaimers.vue?vue&type=script&lang=ts&"
export * from "./Disclaimers.vue?vue&type=script&lang=ts&"
import style0 from "./Disclaimers.vue?vue&type=style&index=0&id=18c4af39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c4af39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
